/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable import/no-cycle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useRef, useEffect } from 'react';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Selection,
  Inject,
  Edit,
  Toolbar,
  Resize,
  Sort,
  Filter,
  Search,
  ForeignKey,
  LazyLoadGroup,
  ExcelExport,
  Group,
} from '@syncfusion/ej2-react-grids';
// ColumnChooser,
import { UploaderComponent } from '@syncfusion/ej2-react-inputs';
import { AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { Tooltip, DialogUtility } from '@syncfusion/ej2-react-popups';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { format, parseISO } from 'date-fns';

import { Query } from '@syncfusion/ej2-data';
import { Link, useNavigate } from 'react-router-dom';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import { useStateContext } from '../contexts/ContextProvider';

import { Header } from '../components';
import profile from '../data/profile.png';
import scribeHow from '../data/scribehow.png';

import './Zackat.css';

const Users = () => {
  // 'ColumnChooser'
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  const grid = useRef(null);
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=users');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const [selUploadOrganization, setUploadOrganization] = useState('');
  const {
    zRenderMode,
    isMobile,
    boss,
  } = useStateContext();
  // Custom formatting logic for Freight
  // Example: format to 3 decimal places with a dollar sign
  const formatTime = (field, data, column) => {
    if (!data || !data[field] || data[field] === '') {
      return '';
    }
    const tm = parseISO(data[field]);
    if (tm.getTime() > 0) {
      return format(tm, 'MM/dd/yy hh:mm');
    }
    return '';
  };
  const ddtf = [
    { _id: false, name: 'false' },
    { _id: true, name: 'true' },
  ];

  const { REACT_APP_API_ENDPOINT } = process.env;
  const valuerules = { required: true };

  const [reload, setReload] = useState(true);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [groups, setGroups] = useState([]);
  const [sortOptions, setSortColumns] = useState({});
  const [crudUpdate, setCrudUpdate] = useState(false);
  const [crudCreate, setCrudCreate] = useState(false);
  const [crudDelete, setCrudDelete] = useState(false);
  const [crudImport, setCrudImport] = useState(false);
  const headerCellInfo = (args) => {
    // Check for a specific column field and attach tooltip
    if (args.cell.column.field === 'email') {
      const tooltip = new Tooltip({
        content: `Tooltip for: ${args.cell.column.headerText}, This is a read only field while editing, if the user needs to change their email address, they must change it under their User Profile`,
      });
      tooltip.appendTo(args.node);
    }
  };
  useEffect(() => {
    if (data.role && data.role.users && data.role.users.permissions.includes('Create')) {
      setCrudCreate(true);
    }
    if (data.role && data.role.users && data.role.users.permissions.includes('Import')) {
      setCrudImport(true);
    }
    if (data.role && data.role.users && data.role.users.permissions.includes('Update')) {
      setCrudUpdate(true);
    }
    if (data.role && data.role.users && data.role.users.permissions.includes('Delete')) {
      setCrudDelete(true);
    }
  }, [data]);
  const invite = { text: 'Invite', tooltipText: 'Resend Invitation', prefixIcon: 'e-resize', id: 'invite', visible: crudUpdate, disabled: false }; // enableDetails
  const add = { text: 'Add', tooltipText: 'Add User', prefixIcon: 'e-add', id: 'add', visible: crudCreate, disabled: false };
  const edit = { text: 'Edit', tooltipText: 'Edit User', prefixIcon: 'e-edit', id: 'edit', visible: crudUpdate, disabled: false };
  const del = { text: 'Delete', tooltipText: 'Delete User', prefixIcon: 'e-delete-2', id: 'delete', visible: crudDelete, disabled: false };
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', disabled: false };

  const toolbarOptions = [add, edit, del, 'Search', invite, excel];
  const onboardGrid = (props) => (
    <div>
      <CheckBoxComponent
        id="onboardChk"
        label="Onboarding"
        name="onboard"
        checked={props.onboard}
      />
    </div>
  );
  const onboardTemplateGrid = (props) => (
    <div>
      <CheckBoxComponent
        id="onboardChk"
        name="onboard"
        checked={props.onboard}
        placeholder="Select Onboarding"
      />
    </div>
  );

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/users?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
      if (mydata.user && mydata.user.preferences && mydata.user.preferences.users) {
        if (mydata.user.preferences.users.group) {
          setGroups(mydata.user.preferences.users.group);
        } else {
          setGroups(['organizationid']);
        }
        if (mydata.user.preferences.users.sort && mydata.user.preferences.users.sort[0].direction) {
          const mysortedColumns = { columns: mydata.user.preferences.users.sort };
          setSortColumns(mysortedColumns);
        }
      } else {
        setGroups(['organizationid']);
      }
      // set state when the data received
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, []);
  const groupOptions = {
    enableLazyLoading: false,
    columns: groups,
  };
  let dialogInstance;

  function dialogOK(f, element) {
    dialogInstance.hide();
  }
  function dialogClick(f, hdr, content, element) {
    let ok = null;
    if (f !== 'na') {
      ok = { text: 'OK', click: () => { dialogOK(f, element); } };
      if (grid && grid.current) {
        const selectedRow = grid.current.getSelectedRecords()[0];
        if (!selectedRow) {
          dialogClick('na', 'User Row', 'No User selected', null);
          return;
        }
      }
    }
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }

  function handleChange(e) {
    let upData = null;
    for (let idx = 0; idx < data.users.length; idx += 1) {
      if (data.users[idx]._id === e.target.id) {
        upData = data.users[idx];
        break;
      }
    }
    const filedata = new FormData();
    const imagedata = e.target.files[0];
    filedata.append('userfile', imagedata);
    if (upData !== null) {
      filedata.append('_id', upData._id);
      filedata.append('fileName', e.target.files[0].name);
    } else {
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/ufileup`, {
      method: 'POST',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
      },
      body: filedata,
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // window.location.reload();
        setReload(!reload);
        dialogClick('na', 'User photo upload', responseJson.response, null);
      })
      .catch((error) => {
        dialogClick('na', 'User photo upload error', error, null);
      });
  }
  const clickHandler = (args) => {
    if (grid && args.item.properties.text === 'Invite') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'User invite', 'Plese select a user!', null);
      } else {
        const recipient = prompt('Please enter the email address on file of the User that you would like to receive the original invitation!', selectedRecords[0].email);
        if (recipient) {
          fetch(`${REACT_APP_API_ENDPOINT}/reinvite?recipient=${recipient}&email=${usr.email}`, {
            method: 'GET',
            headers: {
              Authorization: `JWTToken ${usr.token}`,
            },
          })
            .then((response) => response.json())
            .then((responseJson) => {
              if (responseJson && responseJson.response && responseJson.response !== 'OK') {
                dialogClick('na', 'User invite', responseJson.response, null);
              }
            })
            .catch((error) => {
              dialogClick('na', 'User invite error', error, null);
            });
        }
      }
    } else if (grid && grid.current && args.item.properties.text === 'Edit') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'User Edit', 'Plese select a user!', null);
        return;
      }
      //       grid.current.startEdit(selectedRecords[0]);

      grid.current.startEdit(selectedRecords[0]);
    } else if (grid && args.item.properties.text === 'Add') {
      grid.current.addRecord();
    } else if (grid && args.item.properties.text === 'Delete') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'User Delete', 'Plese select a user!', null);
      } else {
        grid.current.deleteRecord(selectedRecords[0]);
      }
    } else if (grid && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `Users_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(properties);
    }
  };
  function removePhoto(e) {
    let removeData = null;
    for (let idx = 0; idx < data.users.length; idx += 1) {
      if (data.users[idx]._id === e.target.id) {
        removeData = data.users[idx];
        break;
      }
    }
    if (removeData == null || confirm(`Remove photo for ${removeData.first} ${removeData.last}?`) === false) {
      return;
    }
    if (removeData !== null) {
      fetch(`${REACT_APP_API_ENDPOINT}/ufileup`, {
        method: 'DELETE',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(removeData),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          // window.location.reload();
          dialogClick('na', 'User photo delete', responseJson.response, null);
          setReload(!reload);
        })
        .catch((error) => {
          dialogClick('na', 'User photo delete error', error, null);
        });
    }
  }
  const customerGridImage = (props) => (
    <div className="image flex gap-4">
      {!props.image
        ? <input type="file" name="userfile" id={props._id} onChange={handleChange} />
        : (
          <div>
            <img
              className="rounded-full w-10 h-10"
              src={props.image && props.image.length > 0 ? props.image : profile}
              alt="employee"
            />
            <font color="black"><input type="submit" name="remove" id={props._id} value="&#x007F;" onClick={removePhoto} /></font>
          </div>
        )}
    </div>
  );
  if (loading) {
    return <p>Loading... </p>;
  }
  const orgData = [];
  data.organization.forEach((org) => {
    orgData.push({ id: org._id, value: org.title });
  });
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  const roles = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.roles,
      fields: { value: '_id', text: 'name' },
      query: new Query(),
    },
  };
  const actionComplete = (args) => {
    const editedData = args.data;
    if (!grid || !grid.current) {
      return;
    }
    const cols = grid.current.columns;
    for (const col of cols) {
      if (col.headerText === 'Image') {
        col.allowEditing = false;
      }
    }
    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      args.form.elements.namedItem('first').focus();
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.header = `Details of ${args.rowData.first} ${args.rowData.last}`;
        dialog.width = '50vw';
      }
    } else if (args.form && args.requestType === 'add') {
      args.form.elements.namedItem('first').focus();
    } else if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        orgData.forEach((element) => {
          if (element.id === editedData.organizationid) {
            editedData.organizationid = element.id;
            editedData.organization = element.value;
          }
        });
        editedData.lastLogin = '1970-01-01T00:00:00.000Z';

        fetch(`${REACT_APP_API_ENDPOINT}/users`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            if (!responseJson || !responseJson._id || responseJson._id.length === 0) {
              DialogUtility.alert('User add failed');
              args.cancel = true;
              return;
            }
            dialogClick('na', 'User insert', editedData.first, null);
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }
            setReload(!reload);
          })
          .catch((error) => {
            dialogClick('na', 'User insert error', error, null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call

        orgData.forEach((element) => {
          if (element.id === editedData.organizationid) {
            editedData.organizationid = element.id;
            editedData.organization = element.value;
          }
        });
        if (editedData.lastLogin && editedData.lastLogin !== '') {
        // Create a new Date object from the date string
          const dateObject = new Date(editedData.lastLogin);

          // Convert the Date object to an ISO 8601 string
          editedData.lastLogin = dateObject.toISOString();
        } else {
          editedData.lastLogin = '1970-01-01T00:00:00.000Z';
        }

        fetch(`${REACT_APP_API_ENDPOINT}/users`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              args.cancel = true;
            }
            dialogClick('na', 'User update', responseJson.response, null);
            setReload(!reload);
          })
          .catch((error) => {
            dialogClick('na', 'User update error', error, null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'delete') {
      if (args.data) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/users`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              args.cancel = true;
            }
            dialogClick('na', 'User delete', responseJson.response, null);
            setReload(!reload);
          })
          .catch((error) => {
            dialogClick('na', 'User delete error', error, null);
            args.cancel = true;
          });
      }
    }
  };
  function setUserPreferences(pref, val) {
    if (!data.user.preferences) {
      data.user.preferences = {};
    }
    if (!data.user.preferences.users) {
      data.user.preferences.users = {};
    }
    if (pref === 'group') {
      data.user.preferences.users = { group: val, sort: data.user.preferences.users.sort };
    } else if (pref === 'sort') {
      data.user.preferences.users = { group: data.user.preferences.users.group, sort: val };
    }
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // dialogClick('na', 'User update', responseJson.response, null);
      })
      .catch((error) => {
        dialogClick('na', 'User update error', error, null);
      });
  }
  const actionBegin = (args) => {
    if (args.requestType === 'ungrouping' || args.requestType === 'grouping') {
      const index = groups.indexOf(args.columnName);
      if (index > -1 && args.requestType === 'ungrouping') { // only splice array when item is found
        groups.splice(index, 1); // 2nd parameter means remove one item only
      } else if (index === -1 && args.requestType === 'grouping') { // only splice array when item is found
        groups.push(args.columnName); // 2nd parameter means remove one item only
      }
      setUserPreferences('group', groups);
    } else if (args.requestType === 'sorting') {
      setUserPreferences('sort', [{ field: args.columnName, direction: args.direction }]);
    }
    if (args.requestType === 'beginEdit' && args.type === 'actionBegin' && data.user._id === args.rowData._id) {
      dialogClick('na', 'User Edit', 'Please do not attempt to edit your User record!', null);
      args.cancel = true;
    }
    if (!grid || !grid.current) {
      return;
    }
    const cols = grid.current.columns;
    for (const col of cols) {
      if (col.headerText === 'Image') {
        if (args.requestType === 'add' && args.type === 'beginEdit') {
          col.allowEditing = false;
          col.visible = false;
        } else {
          col.visible = true;
        }
      }
      if (col.headerText === 'ID') {
        if (args.requestType === 'add' && args.type === 'beginEdit') {
          col.visible = false;
        } else {
          col.visible = false;
        }
      }

      if (col.headerText === 'Password') {
        if (args.requestType === 'add') {
          col.allowEditing = true;
          col.visible = true;
        } else {
          col.allowEditing = false;
          col.visible = false;
        }
      }
      if (col.headerText === 'Email') {
        if (args.requestType === 'beginEdit' && args.type === 'actionBegin') {
          col.allowEditing = false;
        } else {
          col.allowEditing = true;
        }
      }
    }
  };
  if (!data.role.users.permissions.includes('Read')) {
    return <p>Not authorized...</p>;
  }

  const editing = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    mode: 'Dialog',
  };
  const editingMobile = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    mode: 'Normal',
  };
  function onFileUpload(args) {
    // add addition data as key-value pair.
    const result = orgData.find(({ id }) => id === selUploadOrganization);
    if (!result || !result.value || result.value === '') {
      dialogClick('na', 'Import Users', 'Please select an Organization!', null);
      args.cancel = true;
      return;
    }
    if (!confirm(`Upload to ${result.value}`)) {
      args.cancel = true;
      return;
    }
    args.customFormData = [{ organizationid: selUploadOrganization }];
  }
  function completeUpload(args) {
    window.location.reload();
  }
  let uploadObj;
  const path = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/usersremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/usersupload`,
  };
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };

  const FilterOptions = {
    type: 'FilterBar',
    showFilterBarStatus: true,
    mode: 'Immediate',
  };
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div">
      <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/How_to_Add_a_New_User_and_Invite_Them__YF-fYJF_Q6abJWnEWVYM0A"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Administration" title="Users" />
      </div>
      <div id="droparea">
        {crudImport && (
        <div className="control-section accordion-control-section" style={{ width: '45%' }}>
          <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
            <AccordionComponent>
              <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                <div className="e-input-group">
                  <div className="mt-4"> Import </div>
                </div>
                <div className="mt-2 e-input-group">
                  <div>
                    <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selUploadOrganization} onChange={(v) => { setUploadOrganization(v.value); }} />
                  </div>
                  <UploaderComponent
                    id="fileupload"
                    type="file"
                    ref={(uplaod) => { uploadObj = uplaod; }}
                    asyncSettings={path}
                    buttons={buttons}
                    multiple={false}
                    actionComplete={completeUpload}
                    autoUpload={false}
                    uploading={onFileUpload}
                    allowedExtensions=".csv"
                  />
                </div>
              </div>
            </AccordionComponent>
          </div>
        </div>
        )}
      </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              id="userGrid"
              width="auto"
              headerCellInfo={headerCellInfo}
              dataSource={data.users}
              enableVirtualization={false}
              allowPaging
              pageSettings={{ pageSize: 20, pageCount: 5 }}
              toolbar={toolbarOptions}
              enableStickyHeader
              toolbarClick={clickHandler}
              editSettings={isMobile ? editingMobile : editing}
              allowSorting
              allowResizing
              allowGrouping
              groupSettings={groupOptions}
              allowSelection
              selectionSettings={{ checkoxOnly: true, type: 'Single', checkboxMode: 'ResetOnRowClick' }}
              sortSettings={sortOptions}
              allowExcelExport
              allowFiltering={data && data.users && data.users.length > 0}
              filterSettings={FilterOptions}
              actionComplete={actionComplete}
              actionBegin={actionBegin}
        // showColumnChooser
              allowTextWrap
              ref={grid}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <ColumnDirective
                  field="_id"
                  headerText="ID"
                  width="100"
                  format="C2"
                  visible={false}
                  textAlign="Left"
                  isPrimaryKey
                />
                <ColumnDirective
                  headerText="Image"
                  width="80"
                  textAlign="Center"
                  template={customerGridImage}
                  title="Add a User picture"
                />
                <ColumnDirective
                  field="first"
                  headerText="First"
                  width="120"
                  textAlign="Left"
                  validationRules={valuerules}
                  title="User first name"
                />
                <ColumnDirective
                  field="last"
                  headerText="Last"
                  width="120"
                  textAlign="Left"
                  validationRules={valuerules}
                  title="User last name"
                />
                <ColumnDirective
                  field="email"
                  headerText="Email"
                  validationRules={{ email: true, required: true }}
                  width="120"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="mobile"
                  headerText="Mobile"
                  width="120"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="password"
                  headerText="Password"
                  width="100"
                  visible={false}
                  textAlign="Left"
                />
                <ColumnDirective
                  field="organizationid"
                  headerText="Organization"
                  width="100"
                  textAlign="Left"
                  editType="dropdownedit"
                  validationRules={valuerules}
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="title"
                  dataSource={organizations.params.dataSource}
                />
                <ColumnDirective
                  field="role"
                  headerText="Role"
                  width="100"
                  textAlign="Left"
                  editType="dropdownedit"
                  validationRules={valuerules}
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="name"
                  dataSource={roles.params.dataSource}
                />
                <ColumnDirective
                  field="onboard"
                  headerText="Onboard"
                  width="80"
                  textAlign="Center"
                  editTemplate={onboardGrid}
                  // template={onboardTemplateGrid} // For display mode
                  displayAsCheckBox
                  visible={boss}
                />
                <ColumnDirective
                  field="lastLogin"
                  headerText="Last Login"
                  width="80"
                  textAlign="Left"
                  // template={onboardTemplateGrid} // For display mode
                  valueAccessor={formatTime}
                  visible={boss}
                  allowEditing={false}
                />
              </ColumnsDirective>
              {/* ColumnChooser */}
              <Inject services={[Page, Selection, Toolbar, Edit, Sort, Filter, Search, Resize, ExcelExport, ForeignKey, LazyLoadGroup, Group]} />
            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Users;
